type SearchParamsLike = { get: (name: string) => string | null } | null | undefined;

// Every window of a seasonal promo shares its coupons, so only flavor tells the windows apart.
// The promo link carries flavor, variant and pack_class through to checkout.
export const getPromoAttribution = (
	searchParams: SearchParamsLike,
): { flavor?: string; variant?: string; pack_class?: string } => {
	const flavor = searchParams?.get('flavor');
	const variant = searchParams?.get('variant');
	const packClass = searchParams?.get('pack_class');
	return {
		...(flavor ? { flavor } : {}),
		...(variant ? { variant } : {}),
		...(packClass ? { pack_class: packClass } : {}),
	};
};
